// @ts-strict-ignore
import { createSlice, current, PayloadAction } from '@reduxjs/toolkit'

import { CategoryListProps, TCompareInitialState } from 'store/types/compare'

import { getUniqueArray } from '@/shared/lib/utils/array/getUniqueArray'

const initialState: TCompareInitialState = {
	items: {},
	categoryList: {},
	activeCategory: ``,
	itemsCodes: [],
	specFilter: `all`
}

export type AddCompareItemTypes = {
	productKOD: string
	category: CategoryListProps
}

const compare = createSlice({
	name: `compare`,
	initialState,
	reducers: {
		setActiveCategory: (state, action: PayloadAction<string>) => {
			state.activeCategory = action.payload
		},
		addCompareItemSuccess: (state, action: PayloadAction<AddCompareItemTypes>) => {
			const { productKOD, category } = action.payload
			const { code } = category
			const { items, itemsCodes } = current(state)

			state.categoryList[code] = category
			state.items[code] = getUniqueArray<string>(items[code], productKOD)
			state.itemsCodes = getUniqueArray<string>(itemsCodes, productKOD)
		},
		// Remove item from compare
		removeCompareItem: (
			state,
			action: PayloadAction<{
				productKOD: string
			}>
		) => {
			const { productKOD } = action.payload
			const { items, itemsCodes } = current(state)
			const categoryName = Object.entries(items).find(([, products]) => products.includes(productKOD))[0]

			const categoryKODList = items[categoryName].filter(KOD => KOD !== productKOD)

			state.itemsCodes = itemsCodes.filter(KOD => KOD !== productKOD)

			// If in category of removable item has not any items,
			// remove category in store, or set new item list without item
			if (!categoryKODList.length) {
				// remove key by creating new objects without the categoryName (avoids dynamic delete)
				state.items = Object.fromEntries(Object.entries(state.items).filter(([k]) => k !== categoryName))
				state.categoryList = Object.fromEntries(Object.entries(state.categoryList).filter(([k]) => k !== categoryName))
				// recompute activeCategory — keep existing logic but note categoryList is an object
				const remainingCategories = Object.values(state.categoryList)
				state.activeCategory = remainingCategories.length ? remainingCategories[0].code : ``
			} else {
				state.items[categoryName] = categoryKODList
			}
		},
		// Remove all items from removed category
		clearAllCategoryList: state => {
			const { items } = current(state)
			const categoryCode = state.activeCategory || Object.keys(items)[0]
			// Items from removed category
			const categoryItems = [...items[categoryCode]]

			// Delete chosen category
			state.items = Object.fromEntries(Object.entries(state.items).filter(([k]) => k !== categoryCode))
			state.categoryList = Object.fromEntries(Object.entries(state.categoryList).filter(([k]) => k !== categoryCode))
			state.activeCategory = null
			// Removed all id of products from removed category
			state.itemsCodes = state.itemsCodes.filter(id => !categoryItems.includes(id))
		},
		// Change filter location for product specifications (all|different)
		// eslint-disable-next-line
		changeSpecificationFilter: (state, action: PayloadAction<TCompareInitialState['specFilter']>) => {
			state.specFilter = action.payload
		}
	}
})

export const {
	setActiveCategory,
	addCompareItemSuccess,
	removeCompareItem,
	clearAllCategoryList,
	changeSpecificationFilter
} = compare.actions
export default compare.reducer
